import styled from "styled-components";

export const VariationDocumentsRow: any = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
`;
